import { useState } from 'react'

import type { UpdateVideoEmbedPostPayload } from '@fourthwall/services/dist/MembershipsCreatorApiClient'

import { useImageConfirmMutation } from '../../../hooks/useImageConfirmMutation'
import { useUploadImageMutation } from '../../../hooks/useUploadImageMutation'
import { useUpdateVideoEmbedPostMutation } from './useUpdateVideoEmbedPostMutation'

export const useUpdateVideoEmbedPost = () => {
  const [isLoading, setLoading] = useState(false)

  const { updateVideoEmbedPostMutation } = useUpdateVideoEmbedPostMutation()

  const { uploadImageMutation } = useUploadImageMutation()
  const { imageConfirmMutation } = useImageConfirmMutation()

  const updateVideoEmbedPost = async (
    id: string,
    thumbnail: File | string | undefined,
    payload: UpdateVideoEmbedPostPayload,
    handleSuccess: () => void,
  ) => {
    setLoading(true)

    const onSuccess = () => {
      setLoading(false)
      handleSuccess()
    }

    const { postId, imageDirectUploadData } = await updateVideoEmbedPostMutation.mutateAsync(
      [Number(id), { ...payload }],
      {
        onSuccess: ({ imageDirectUploadData }) => {
          // Update text fields only
          if (!imageDirectUploadData) {
            onSuccess()
          }
        },
        onError: () => setLoading(false),
      },
    )

    if (imageDirectUploadData) {
      await uploadImageMutation.mutateAsync([thumbnail as File, { ...imageDirectUploadData }], {
        onError: () => {
          setLoading(false)

          throw new Error('Memberships: update video embed post upload image error')
        },
      })

      await imageConfirmMutation.mutate([postId, { signedId: imageDirectUploadData.signedId }], {
        onSuccess,
        onError: () => {
          setLoading(false)

          throw new Error('Memberships: update video embed post confirm image error')
        },
      })
    }
  }

  return {
    updateVideoEmbedPost,
    isLoading,
  }
}
